import React, { useState, useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from './firebase/config';
import { ThemeProvider } from './ThemeContext';
import { LanguageProvider } from './LanguageContext';
import Login from './pages/Login';
import CommercialHome from './pages/CommercialHome';
import ManagerHome from './pages/ManagerHome';
import useNotificationsAuto from './hooks/useNotificationsAuto';

function AppContent({ user, setUser }) {
  useNotificationsAuto(user);

  if (!user) return <Login onLogin={setUser} />;
  if (user.role === 'manager') return <ManagerHome user={user} onLogout={() => setUser(null)} />;
  return <CommercialHome user={user} onLogout={() => setUser(null)} />;
}

export default function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        const userDoc = await getDoc(doc(db, 'users', firebaseUser.uid));
        if (userDoc.exists()) {
          setUser({ uid: firebaseUser.uid, ...userDoc.data() });
        }
      } else {
        setUser(null);
      }
      setLoading(false);
    });
    return () => unsub();
  }, []);

  if (loading) return (
    <ThemeProvider>
      <LanguageProvider>
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f5f5' }}>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 32, marginBottom: 12 }}>📍</div>
            <div style={{ fontSize: 16, color: '#C0392B', fontWeight: 600 }}>Activiter Commercial</div>
            <div style={{ fontSize: 13, color: '#888', marginTop: 8 }}>Chargement...</div>
          </div>
        </div>
      </LanguageProvider>
    </ThemeProvider>
  );

  return (
    <ThemeProvider>
      <LanguageProvider>
        <AppContent user={user} setUser={setUser} />
      </LanguageProvider>
    </ThemeProvider>
  );
}
